import isApiError from "@insite/client-framework/Common/isApiError";
import { ServiceResult, get } from "@insite/client-framework/Services/ApiService";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export interface RecommendedProductAPIParameter {
    scenario: string;
    channelId: string;
    catalogId: string;
    modeling: string;
    algoType: string;
    count: number;
    userId: string | undefined;
    skipItems: number;
    erpNumber: string;
}

export interface RecommendedProductModel {
    uri: string;
    products: [];
    properties: {};
}

const url = "api/v1/getProductRecommendations";

export async function getRecommendedProduct(
    parameter: RecommendedProductAPIParameter,
): Promise<ServiceResult<ProductModel>> {
    try {
        const resultModel = await get<ProductModel>(`${url}/`, parameter as any);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
